// src/pages/Doctors/DoctorDetails.jsx

import DoctorsBanner from "../Doctors/DoctorsBanner";
import BookAppointment from "../home/BookAppointment";
import BookAppointmentMobile from "../home/BookAppointmentMobile";
import AboutDoctors from "../About/AboutDoctors";
import EastIcon from "@mui/icons-material/East";
import { doctors } from "../../doctorsData/Doctors";
import { Link, useParams  } from "react-router-dom";

export default function DoctorDetails() {
  
const { slug } = useParams();

const doctor = doctors.find(
  (item) => item.slug === slug
);

  if (!doctor) {
    return (
      <div className="text-center py-20 text-xl font-semibold">
        Doctor Not Found
      </div>
    );
  }

  return (
    <div className="font-manrope">
      <DoctorsBanner />

      {/* MAIN SECTION */}
      <div className="w-[95%] max-w-[1400px] mx-auto py-16 lg:flex block gap-10">
        {/* LEFT SIDE */}
        <div className="w-full md:w-[35%] h-fit">
          <div className="bg-[#dbe7f3] rounded-[20px] p-6 shadow-sm">
            <img
              src={doctor.image}
              alt={doctor.name}
              className="rounded-[16px] w-auto h-auto mx-auto"
            />

            <h2 className="text-[24px] font-semibold mt-4 text-[#000]">
              {doctor.name}
            </h2>

            <p className="text-[13px] font-medium text-[#000] mt-1">
              {doctor.dignity}
            </p>

            <p className="text-sm text-[#4D6E76] mt-3 leading-6">
              {doctor.degree}
            </p>

            {/* DETAILS */}
            {/* DETAILS */}
         <div className="mt-5 space-y-3 text-[14px] text-[#000]">

  {/* EXPERIENCE */}
  <p className="flex items-center gap-2">
    <span>🏆</span>
    <span>{doctor.experience} Years+ Experience</span>
  </p>

  {doctor.details?.map((detail, index) => {
    let icon = "✅";

    if (detail.includes("Gender")) {
      icon = "👨";
    } else if (detail.includes("Languages")) {
      icon = "🌐";
    } else if (detail.includes("Consultation")) {
      icon = "🗓️";
    } else if (detail.includes("Prachin")) {
      icon = "📍";
    }

    return (
      <p key={index} className="flex items-center gap-2">
        <span>{icon}</span>
        <span>{detail}</span>
      </p>
    );
  })}
</div>

            {/* BUTTON */}
            <Link
              to="/contact"
              className="mt-5 flex items-center justify-center text-center gap-3 bg-[#094ca0] text-white px-5 py-2.5 rounded-full w-fit"
            >
              <span className="text-[14px] font-manrope text-center">
                Get Your Consultation
              </span>

              <span className="bg-white text-[#094ca0] rounded-full w-8 h-8 flex items-center justify-center">
                <EastIcon fontSize="small" />
              </span>
            </Link>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="w-full md:w-[55%] mt-10 md:mt-0 space-y-10">
          {/* ABOUT */}
          <div>
            <h2 className="text-[22px] xl:text-[32px] font-semibold mb-4 text-[#000]">
              About Doctor
            </h2>

            {doctor.about?.map((item, index) => (
              <p
                key={index}
                className="text-gray-600 leading-7 text-[14px] 3xl:text-[15px] text-justify mt-2"
                dangerouslySetInnerHTML={{ __html: item }}
              />
            ))}
          </div>

          {/* PROFESSIONAL DETAILS */}
          <div>
            <h2 className="text-[22px] xl:text-[32px] font-semibold mb-4 text-[#0b2c4d]">
              Professional Details
            </h2>

            <div className="space-y-4 text-[14px] 3xl:text-[15px]">
              <div className="flex justify-between border-b pb-2">
                <span className="text-gray-500">Specialization</span>
                <span className="font-medium">{doctor.specialization}</span>
              </div>

              <div className="flex justify-between border-b pb-2">
                <span className="text-gray-500">Current Role</span>
                <span className="font-medium">{doctor.currentRole}</span>
              </div>
                 <div className="flex justify-between border-b pb-2">
                <span className="text-gray-500">Experience</span>
                <span className="font-medium">{doctor.experience}years +</span>
              </div>
            </div>
          </div>

          {/* EDUCATION */}
          <div>
            <h2 className="text-[22px] xl:text-[32px] font-semibold mb-4 text-[#0b2c4d]">
              Education & Training
            </h2>

            <ul className="list-disc pl-5 text-gray-600 space-y-2 text-[14px] 3xl:text-[15px]">
              {doctor.education?.map((edu, index) => (
                <li key={index}>{edu}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <AboutDoctors />

      {/* MOBILE */}
      <div className="block xl:hidden">
        <BookAppointmentMobile />
      </div>

      {/* DESKTOP */}
      <div className="hidden xl:block my-20">
        <BookAppointment />
      </div>
    </div>
  );
}
